export default "__VITE_ASSET__DVKoWGw___"